<template>
  <div class="wetravel-button-container w-1/2 flex items-center justify-center">
    <button
      @click="initiatePayment"
      :disabled="loading"
      class="wetravel-button"
    >
      <span v-if="loading" class="loading-spinner"></span>
      <span v-else>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block mr-2">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.94s4.18 1.36 4.18 3.85c0 1.89-1.44 2.98-3.12 3.19z" fill="currentColor"/>
        </svg>
        Pay with WeTravel
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "WeTravelButton",
  props: {
    amount: {
      type: Number,
      required: true,
    },
    bookingId: {
      type: String,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async initiatePayment() {
      this.loading = true;
      try {
        const params = new URLSearchParams(window.location.search);
        const tripName = params.get("Code") || "Trip Booking";

        const headers = {
          Accept: "application/json",
          "Content-Type": "application/json",
        };

        const response = await window.api.post(
          "/api/wetravel/pay",
          JSON.stringify({
            amount: this.amount,
            currency: "USD",
            bookingId: this.bookingId,
            tripName: tripName,
            startDate: this.startDate,
            endDate: this.endDate,
          }),
          headers
        );

        if (response && response.payment_url) {
          window.location.href = response.payment_url;
        } else if (response && response.key) {
          console.warn("Payment link created but no URL returned");
          alert("Payment link created. Please check your email for the payment link.");
        } else {
          throw new Error("No payment URL received from server");
        }
      } catch (error) {
        console.error("Error initiating WeTravel payment:", error);
        alert("Error creating payment. Please try again.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.wetravel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #0070f3;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.wetravel-button:hover:not(:disabled) {
  background-color: #0060df;
  transform: translateY(-1px);
}

.wetravel-button:active:not(:disabled) {
  transform: translateY(0);
}

.wetravel-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
